import {
    AccordionItem,
    AccordionPanel,
    ChipAccordionPanel,
} from 'components/Accordion';
import FilterAccordionButton from './FilterAccordionButton';
import { formatVolume } from 'utils/helpers';
import { useUID } from 'react-uid';
import { withMixpanelChange } from 'utils/app';

const AccordionPanelStack = AccordionPanel;

const FilterAccordionItemUntracked = ({
    children,
    panelId,
    abbrTitleHTML,
    label: itemLabel,
    options,
    isOpen,
    toggleOpen,
    appliedFilters,
    onChange,
    AccordionPanel = AccordionPanelStack,
    ChipAccordionPanel: ChipAccordionPanelComponent = ChipAccordionPanel,
    FilterAccordionButton: FilterAccordionButtonProp = FilterAccordionButton,
    Icon,
    FilterOption,
    FilterChipItemButton,
    showChipsWhenClosed = true,
    space,
    status,
    noDataMessage,
    normalizeValue,
}) => {
    const hasActiveFilters = !!appliedFilters && appliedFilters.length > 0;
    const PanelComponent = isOpen
        ? AccordionPanel
        : ChipAccordionPanelComponent;
    const panelProps = isOpen ? { $space: space } : {};
    const stableId = useUID();

    return (
        <AccordionItem $isOpen={isOpen}>
            {FilterAccordionButtonProp && (
                <FilterAccordionButtonProp
                    onClick={(e) => toggleOpen()}
                    isActive={isOpen}
                    isOpen={isOpen}
                    Icon={Icon}
                    {...(isOpen && {
                        'aria-controls': `${stableId}-${panelId}`,
                    })}
                >
                    {abbrTitleHTML ? (
                        <span
                            dangerouslySetInnerHTML={{ __html: abbrTitleHTML }}
                        />
                    ) : (
                        <span>{itemLabel}</span>
                    )}
                </FilterAccordionButtonProp>
            )}
            {isOpen && !(options && options.length) && status === 'loading' ? (
                <PanelComponent {...panelProps} id={`${stableId}-${panelId}`}>
                    <FilterOption
                        checked={false}
                        disabled={true}
                        isLoading={true}
                    />
                </PanelComponent>
            ) : isOpen &&
              !(options && options.length) &&
              status !== 'loading' &&
              noDataMessage ? (
                <PanelComponent {...panelProps} id={`${stableId}-${panelId}`}>
                    <span>{noDataMessage}</span>
                </PanelComponent>
            ) : isOpen || (showChipsWhenClosed && hasActiveFilters) ? (
                <PanelComponent {...panelProps} id={`${stableId}-${panelId}`}>
                    {options.map((option) => {
                        const { label, value, count, volume } = option;
                        const checked =
                            !!appliedFilters &&
                            (normalizeValue
                                ? appliedFilters.some(
                                      (appliedValue) =>
                                          normalizeValue(appliedValue) ===
                                          normalizeValue(value),
                                  )
                                : appliedFilters.includes(value));

                        return isOpen ? (
                            <FilterOption
                                checked={checked}
                                onChange={() =>
                                    onChange({
                                        action: checked
                                            ? 'remove-value'
                                            : 'select-option',
                                        option,
                                    })
                                }
                                {...option}
                                key={value}
                            >
                                {label}{' '}
                                {count || count === 0 ? (
                                    <span
                                        css={`
                                            font-weight: 500;
                                            margin-left: 0.5rem;
                                            color: ${({ theme }) =>
                                                theme.gray_600};
                                        `}
                                    >
                                        {count}
                                    </span>
                                ) : null}
                                {volume || volume === 0 ? (
                                    <span
                                        css={`
                                            font-weight: 500;
                                            margin-left: 0.5rem;
                                            color: ${({ theme }) =>
                                                theme.gray_600};
                                            text-transform: uppercase;
                                        `}
                                    >
                                        {formatVolume(volume)}
                                    </span>
                                ) : null}
                            </FilterOption>
                        ) : checked ? (
                            <FilterChipItemButton
                                onClick={() =>
                                    onChange({ action: 'remove-value', option })
                                }
                                {...option}
                                key={value}
                            >
                                {label}
                            </FilterChipItemButton>
                        ) : null;
                    })}
                </PanelComponent>
            ) : null}
            {isOpen ? children : null}
        </AccordionItem>
    );
};

export const handleMixpanelEvent = ({ action, option }) => {
    switch (action) {
        case 'select-option':
        case 'remove-value':
            return {
                action,
                label: option.label,
                value: option.value,
            };
        default:
            return { action };
    }
};

const FilterAccordionItemWithMixpanel = withMixpanelChange(
    FilterAccordionItemUntracked,
    'FilterAccordionItem',
);
export const FilterAccordionItem = ({
    handleMixpanelEvent: handleMixpanelEventProp = handleMixpanelEvent,
    ...props
}) => {
    return (
        <FilterAccordionItemWithMixpanel
            handleMixpanelEvent={handleMixpanelEventProp}
            {...props}
        />
    );
};

export default FilterAccordionItem;
